// Cognito access token for API/chat requests. The backend (require_caller /
// resolve_caller_from_event) validates it via cognito-idp:GetUser. Slice AUTH
// replaced the old x-dev-* header bypass with this.
import { fetchAuthSession } from "aws-amplify/auth";

const HEADER = "x-cognito-access-token";

/** Current Cognito access token, or null if not signed in. */
export async function getAccessToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.accessToken?.toString() ?? null;
  } catch {
    return null;
  }
}

/** Attach the Cognito access token to a Headers object. Throws if not signed
 *  in — callers run behind the auth gate, so this is a real error. */
export async function withAuthHeader(headers: Headers): Promise<Headers> {
  const token = await getAccessToken();
  if (!token) throw new Error("not authenticated");
  headers.set(HEADER, token);
  return headers;
}
